export default __webpack_public_path__ + "static/media/Thunderstorm.80dfe35c.svg";